import React, { useState, useEffect, lazy, Suspense } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/football.webp";
const BlinkingText = lazy(() => import('../../BlinkingText'));
const RelatedLinks = lazy(() => import('../RelatedLinks'));
const MainCalculatorsList = lazy(() => import('./MainCalculators'));

const TITLE = "Décompte jusqu'à la Coupe d'Asie 2027 - Jours restants";
const DESCRIPTION = "Combien de jours restants jusqu'à la Coupe d'Asie AFC 2027 ? Le décompte jusqu'à la Coupe d'Asie vous fournit des informations précises sur la date de début du tournoi footballistique le plus important d'Asie.";
const KEYWORDS = "Coupe d'Asie 2027, AFC 2027, décompte Coupe d'Asie, date Coupe d'Asie 2027, combien de jours jusqu'à la Coupe d'Asie 2027";
const OG_URL = "https://do-calculate.com/articles-fr/asian-cup";

function AFCAsianCupCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const asianCupDate = new Date("2027-01-12T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(asianCupDate));

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(asianCupDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);

    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className="p-3 mb-2 bg-success text-white">Décompte jusqu'à la Coupe d'Asie 2027</h1>
            <Suspense fallback={<div>Chargement...</div>}>
                <BlinkingText text="Décompte jusqu'à la Coupe d'Asie : le tournoi devrait débuter le mardi 12 janvier 2027 au Qatar." />
            </Suspense>
            <div className="row">
                <div id="timer" style={{ width: '100%', textAlign: 'center' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Jours</th>
                                <th className="bmi-header">Heures</th>
                                <th className="bmi-header">Minutes</th>
                                <th className="bmi-header">Secondes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days ?? 0}</td>
                                <td>{timeLeft.hours ?? 0}</td>
                                <td>{timeLeft.minutes ?? 0}</td>
                                <td>{timeLeft.seconds ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Informations sur la Coupe d'Asie 2027</h3>
                    <p>
                        La Coupe d'Asie est le tournoi de football le plus important du continent asiatique, où les équipes nationales de nombreux pays asiatiques s'affrontent pour remporter le titre. La Coupe d'Asie 2027 se tiendra au Qatar, et cette édition est particulièrement spéciale car ce sera la deuxième fois que le Qatar accueille la compétition après 2011.
                    </p>
                    <p>
                        On prévoit que le tournoi réunira 24 équipes nationales de différentes régions du continent asiatique, et que les compétitions seront plus passionnantes que jamais.
                    </p>
                    <hr />
                    <Suspense fallback={<div>Chargement...</div>}>
                        <RelatedLinks />
                    </Suspense>
                </div>
                <div className="col-sm-4 col-md-4">
                    <Suspense fallback={<div>Chargement...</div>}>
                        <MainCalculatorsList />
                    </Suspense>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">La Coupe d'Asie AFC</h3>
                    <p>
                        La Coupe d'Asie de l'AFC (Confédération Asiatique de Football) est organisée tous les quatre ans et est la principale compétition de football pour les nations asiatiques. Elle détermine le champion d'Asie et constitue une étape importante dans le développement du football asiatique sur la scène mondiale.
                    </p>
                    <div>
                        <br />
                        <img
                            src={imageUrl}
                            alt="Décompte jusqu'à la Coupe d'Asie 2027"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                </div>
            </div>
            <MobileUnderCalAds />
        </div>
    );
}

export default AFCAsianCupCountdown;
